module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Moviles-5.b3cf5826.png";